import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { formatImgUrl } from "../../../../../../../utils/cardFormating";
import WorldMapLocations from "../../../../../../../shared/WorldMapLocations";
import { useGetCountriesWithCoordinates } from "../../../../../../../api/v1/queries/useGetCountriesWithCoordinates";

const CandidatesLocations = ({ countries }: { countries: any[] }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.previewAndPublishJob" });

  const { countriesWithCoordinates, isCountriesWithCoordinatesLoading } = useGetCountriesWithCoordinates();

  // Filter out undefined values and ensure we have valid country data
  const countriesList = countries
    .map((country) => {
      const countryId = typeof country === "object" ? country.value : country;
      return countriesWithCoordinates?.find((c: any) => c.id === countryId);
    })
    .filter((country): country is NonNullable<typeof country> => country !== undefined);

  const MapLocations = countriesList.map(({ name, latitude, longitude }) => ({
    country: name,
    coordinates: [Number(latitude), Number(longitude)] as [number, number],
  }));

  if (isCountriesWithCoordinatesLoading || countriesList.length === 0) {
    return null;
  }

  return (
    <Box component="section" sx={styles.container}>
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.title}>{t("thePerfectCandidateShouldBeFrom")}</Typography>
        <Box sx={styles.flagsContainer}>
          {countriesList.map(({ name, url }) => (
            <Box key={name} sx={styles.country}>
              <Box component="img" src={formatImgUrl(url)} sx={styles.flag} alt={name} />
              <Typography>{name}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <WorldMapLocations countries={MapLocations} />
    </Box>
  );
};

export default CandidatesLocations;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  flag: {
    width: "20px",
    height: "20px",
  },
  flagsContainer: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
  },
  country: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
};
